import { CircularProgress } from '@material-ui/core';
import React, { useEffect } from 'react';

import {
  UpdateBoardInput,
  useDeleteBoardMutation,
  useGetBoardByIdLazyQuery,
  useUpdateBoardMutation,
} from '../../../../graphql/gen/types';
import { logAnalytics } from '../../shared/logAnalytics';
import { useDialogState } from '../useDialogState';
import { BaseBoardDialog } from './BaseBoardDialog';

type Props = {
  boardId: string;
};

export function EditBoardDialog(props: Props): React.ReactElement {
  const { boardId } = props;
  const [dialogState, setDialogState] = useDialogState();
  const [getBoard, { data }] = useGetBoardByIdLazyQuery({ variables: { boardId } });
  const [updateBoardMutation, { loading, error }] = useUpdateBoardMutation();
  const open = !!dialogState && dialogState?.type === 'edit_board';
  const [deleteBoardMutation] = useDeleteBoardMutation();

  useEffect(() => {
    // Trigger query once dialog is open
    if (open) {
      getBoard();
    }
  }, [getBoard, open]);

  const onClose = (): void => {
    setDialogState(null);
  };

  const handleUpdateBoard = (board: UpdateBoardInput): void => {
    updateBoardMutation({
      variables: { id: boardId, board },
    }).then(({ data }) => {
      if (data?.updateBoard?.id != null) {
        onClose();
        logAnalytics({ name: 'updated board', details: { plexId: data?.updateBoard?.id } });
      }
    });
  };

  const onDelete = async (faqDestinationBoard: string, deleteAllFaqs: boolean): Promise<void> => {
    const { data: deletedData } = await deleteBoardMutation({
      variables: { boardId, faqDestinationBoard, deleteAllFaqs },
    });
    if (deletedData?.deleteBoard?.id != null) {
      onClose();
      logAnalytics({
        name: 'deleted board',
        details: { plexId: data?.loggedIn?.boardById?.plexId, itemId: deletedData.deleteBoard.id },
      });
    }
  };

  const board = data?.loggedIn?.boardById;

  if (!board) {
    return <CircularProgress size={24} />;
  }

  return (
    <BaseBoardDialog
      board={board}
      boardId={board.id}
      mode={'update'}
      onSave={handleUpdateBoard}
      onDelete={onDelete}
      saveLoading={loading}
      saveError={error}
    />
  );
}
